import { BACKEND_URL_STORE } from '@constants/server.constant'
import axios from 'axios'

export const listConfigs = () => axios.get(`${BACKEND_URL_STORE}/config`)

// Whether the "Read" (blog) module is enabled — controlled by the admin toggle (custom config
// `show_read_module`). Server-safe (used in getServerSideProps / getStaticProps to 404 the /read pages).
// Default = hidden (false) when not set or the config can't be read, matching the "hide until ready" intent.
export const isReadModuleEnabled = async (): Promise<boolean> => {
  try {
    const { data } = await listConfigs()
    return String(data?.show_read_module?.value) === 'true'
  } catch {
    return false
  }
}
